// src/components/ProtectedRoute.js
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../../AuthContext';

const ProtectedRoute = () => {
  const { user, isSignInLoading } = useAuthContext();

  if (isSignInLoading) {
    return <div>Loading...</div>; 
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
